export const INCOME = {
  isHidden: true,
  nickname: 'PRODUCTS.INCOME.nickname',
  icon:'income'
};
